export const getOrgInitials = (name?: string | null): string => {
  if (!name || name.trim().length === 0) return "";

  const words = name.trim().split(/\s+/);
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};
